/**
 * Align related articles using Uniformify
 */
$(function() {
    $('.blog-articles.related').uniformify();
});
